export const isEmptyObject = (obj) =>
  obj !== null && typeof obj === "object" && Object.keys(obj).length === 0;
